import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePatients } from './hooks/usePatients'

const Patient = () => {
    const patients = usePatients()
    const navigate = useNavigate()
    const {id} = useParams()
    console.log('id: ', id)
    const currentPatient = patients.find( o => o._id === id)
    console.log('currentPatient: ', currentPatient)
  return (
    <div>
        <h1>Patient</h1>
        {currentPatient && 
        <ul>
            <li>Name: {currentPatient?.name}</li>
            <li>phone: {currentPatient?.phone}</li>
            <li>Previous Visited: {currentPatient?.previous_visited}</li>
            <li>Purpose of Visit: {currentPatient?.visited_purpose}</li>
        </ul>
        }
        <button onClick={() => navigate('/')}>Back</button>
    </div>
  )
}

export default Patient